import { CustomField } from "@/backend/models/customFields/customField";
import { StringCustomField } from "@/backend/models/customFields/stringCustomField";
import { MultilineTextCustomField } from "@/backend/models/customFields/multilineTextCustomField";
import { IntCustomField } from "@/backend/models/customFields/intCustomField";
import { FloatCustomField } from "@/backend/models/customFields/floatCustomField";
import { BoolCustomField } from "@/backend/models/customFields/boolCustomField";
import { CUSTOM_FIELD_TYPES, CustomFieldParams } from "@/types/customFieldTypes";
import { ObjectCustomField } from "@/backend/models/customFields/objectCustomField";
import { FileCustomField } from "@/backend/models/customFields/fileCustomField";
import { ValidationCustomField } from "@/backend/models/customFields/validationCustomField";

export class CustomFieldBuilder {
  public build(data: CustomFieldParams): CustomField {
    switch (data.fieldType) {
      case CUSTOM_FIELD_TYPES.String: {
        return new StringCustomField(data);
      }
      case CUSTOM_FIELD_TYPES.MultilineText: {
        return new MultilineTextCustomField(data);
      }
      case CUSTOM_FIELD_TYPES.Integer: {
        return new IntCustomField(data);
      }
      case CUSTOM_FIELD_TYPES.Float: {
        return new FloatCustomField(data);
      }
      case CUSTOM_FIELD_TYPES.Boolean: {
        return new BoolCustomField(data);
      }
      case CUSTOM_FIELD_TYPES.Object: {
        return new ObjectCustomField(data);
      }
      case CUSTOM_FIELD_TYPES.File: {
        return new FileCustomField(data);
      }
      case CUSTOM_FIELD_TYPES.Validation: {
        return new ValidationCustomField(data);
      }
      default: {
        return new CustomField(data);
      }
    }
  }
}
